export const artist = {
  Artist: 'Artista',
  'Verified Artist': 'Artista verificado',
  followers: 'seguidores',
  Discography: 'Discografía',
  'Popular releases': 'Lanzamientos populares',
  Popular: 'Popular',
  Albums: 'Álbumes',
  Singles: 'Sencillos',
  All: 'Todos',
  Compilations: 'Compilaciones',
  'Singles and EPs': 'Sencillos y EPs',
  'Appears on': 'Aparece en',
  'Show more': 'Mostrar más',
  'Show all': 'Mostrar todos',
  'Show less': 'Mostrar menos',
  Follow: 'Seguir',
  Unfollow: 'Dejar de seguir',
  'Fans also like': 'A los fans también les gusta',
};
